import { useState } from 'react';
import { faqs } from '@/mocks/guatian';

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-accent-100/40 py-12 md:py-16">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <p className="mb-2 inline-flex items-center gap-2 rounded-full bg-accent-200 px-3 py-1 text-xs font-medium text-accent-800">
            <i className="ri-question-mark" aria-hidden="true" /> 吃瓜小课堂
          </p>
          <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">关于瓜田的常见问题</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            这里也写清了瓜田网的采编立场：吃瓜有底线，热点不误伤。了解更多，才能更放心地吃瓜。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={`overflow-hidden rounded-2xl border bg-background-50 transition ${
                  isOpen ? 'border-accent-300' : 'border-background-200'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left md:px-6"
                  aria-expanded={isOpen}
                >
                  <span className="flex items-center gap-3 text-[15px] font-semibold text-foreground-900">
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs ${
                        isOpen ? 'bg-accent-500 text-accent-950' : 'bg-accent-200 text-accent-800'
                      }`}
                    >
                      {isOpen ? '×' : '？'}
                    </span>
                    {f.q}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-xl text-foreground-500 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                    aria-hidden="true"
                  />
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4 md:px-6">
                    <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}